import { Media } from '@ionic-native/media';
import { NodeToImgService } from './../providers/nodetoimg.service';
import { TouItemComponent } from './../pages/apps/gamer/components/tou-item/tou-item';
import { EventsLauncherPage } from './../pages/events-launcher/events-launcher';
import { AddAthletePage } from './../pages/add-athlete/add-athlete';
import { EventOrganizerPage } from './../pages/event/details/event-organizer/event-organizer';
import { MenuEntriesService } from './../providers/menu-entries.service';
import { ScanService } from './../providers/scan.service';
import { CountdownComponent } from './../components/show-modal/show-modal';
import { TakeSelfiePage } from './../pages/me/mysport/mysport-results/mysport-results-menu/take-selfie/take-selfie';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { Admob } from '@ionic-native/admob';
import { AppVersion } from '@ionic-native/app-version';
import { Camera } from '@ionic-native/camera';
import { Device } from '@ionic-native/device';
import { Facebook } from '@ionic-native/facebook';
import { Geolocation } from '@ionic-native/geolocation';
import { GooglePlus } from '@ionic-native/google-plus';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Push } from '@ionic-native/push';
import { SocialSharing } from '@ionic-native/social-sharing';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { TapticEngine } from '@ionic-native/taptic-engine';
import { IonicStorageModule, Storage } from '@ionic/storage';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IonicApp, IonicErrorHandler, IonicModule, IonicPageModule, NavController, ToastController } from 'ionic-angular';
import { EventSearchListItemComponent } from '../components/event-search-list-item/event-search-list-item';
import { GoogleMapsComponent } from '../components/google-maps/google-maps';
import { ImageContainerComponent } from '../components/image-container/image-container';
import { MyEventListItemComponent } from '../components/my-event-list-item/my-event-list-item';
import { MysportIconComponent } from '../components/mysport-icon/mysport-icon';
import { MysportProfileListItemComponent } from '../components/mysport-profile-list-item/mysport-profile-list-item';
import { MysportSportartListItemComponent } from '../components/mysport-sportart-list-item/mysport-sportart-list-item';
import { ResultRanglistListItemComponent } from '../components/result-ranglist-list-item/result-ranglist-list-item';
import { ResultSearchListItemComponent } from '../components/result-search-list-item/result-search-list-item';
import { ScoreBoardModal } from '../components/score-board-modal/score-board-modal';
import { ScoreBoardEinzel } from '../components/score-board-einzel/score-board-einzel';
import { RaceByBib } from '../components/race-by-bib-component/race-by-bib';
import { LeaderActivity } from '../components/leader-activity/leader-activity';
import { RaceByName } from '../components/race-by-name-component/race-by-name';
import { TrophyComponent } from '../components/trophy/trophy';
import { GoogleAdsDirective } from '../directives/google-ads/google-ads';
import { ScrollHideDirective } from '../directives/scroll-hide';
import { EventCreateRacePage } from '../pages/event/create/event-create-race/event-create-race';
import { EventCreateTabsPage } from '../pages/event/create/event-create-tabs/event-create-tabs';
import { EventCreatePage } from '../pages/event/create/event-create/event-create';
import { FotosPage } from '../pages/event/create/fotos/fotos';
import { InfosPage } from '../pages/event/create/infos/infos';
import { KontaktPage } from '../pages/event/create/kontakt/kontakt';
import { EventDetailInfoPage } from '../pages/event/details/event-detail-info/event-detail-info';
import { EventDetailsMapPage } from '../pages/event/details/event-details-map/event-details-map';
import { EventDetailsPage } from '../pages/event/details/event-details/event-details';
import { EventKontaktPage } from '../pages/event/details/event-kontakt/event-kontakt';
import { EventTabsPage } from '../pages/event/details/event-tabs/event-tabs';
import { EventListPage } from '../pages/event/event-list/event-list';
import { EventSearchMapPage } from '../pages/event/main/event-search-map/event-search-map';
import { EventSearchPage } from '../pages/event/main/event-search/event-search';
import { LoginPage } from '../pages/login/login/login';
import { RegistrationPage } from '../pages/login/registration/registration';
import { MysportContactsPage } from '../pages/me/mysport/mysport-contacts/mysport-contacts';
import { MysportEventsPage } from '../pages/me/mysport/mysport-events/mysport-events';
import { MysportFriendsPage } from '../pages/me/mysport/mysport-friends/mysport-friends';
import { MysportPhotosPage } from '../pages/me/mysport/mysport-photos/mysport-photos';
import { MysportResultsPage } from '../pages/me/mysport/mysport-results/mysport-results';
import { MysportResultsMenuPage } from '../pages/me/mysport/mysport-results/mysport-results-menu/mysport-relults-menu';
import { MysportUserProfilePage } from '../pages/me/mysport/mysport-user-profile/mysport-user-profile';
import { MeSettingsSportartsPage } from '../pages/me/settings/me-settings-sportarts/me-settings-sportarts';
import { PrivateProfilePhotosPage } from '../pages/me/settings/private-profile-photos/private-profile-photos';
import { PrivateProfilePage } from '../pages/me/settings/private-profile/private-profile';
import { SettingsPage } from '../pages/me/settings/settings/settings';
import { NearbyMapPage } from '../pages/nearby/main/nearby-main';
import { NearbyMainResolver } from '../pages/nearby/main/nearby-main-resolver';
import { NearbyEventParticipantSearchPage } from '../pages/nearby/nearby-event-participant-search/nearby-event-participant-search';
import { NearbyEventParticipantsPage } from '../pages/nearby/nearby-event-participants/nearby-event-participants';
import { NearbyModifyStartPage } from '../pages/nearby/nearby-modify-start/nearby-modify-start';
import { NotificationPage } from '../pages/notification/main/notification';
import { NotificationDetailsPage } from '../pages/notification/details/notification-details';
import { PictureViewerPage } from '../pages/picture-viewer/picture-viewer';
import { ResultCreatePagerPage } from '../pages/results/result-create-pager/result-create-pager';
import { ResultDetailsPage } from '../pages/results/result-details/result-details';
import { ResultEditTrophyPage } from '../pages/results/result-edit-trophy/result-edit-trophy';
import { ResultProfilePage } from '../pages/results/result-profile/result-profile';
import { ResultRanglistPage } from '../pages/results/result-ranglist/result-ranglist';
import { ResultSearchPage } from '../pages/results/result-search/result-search';
import { TabsPage } from '../pages/tabs/tabs';
import { TextBuildingServicesPage } from '../pages/textPages/text-building-services/text-building-services';
import { TextContactPage } from '../pages/textPages/text-contact/text-contact';
import { TextCookiesPage } from '../pages/textPages/text-cookies/text-cookies';
import { TextDataProtectPage } from '../pages/textPages/text-data-protect/text-data-protect';
import { TextImpressPage } from '../pages/textPages/text-impress/text-impress';
import { WelcomePage } from '../pages/welcome/welcome';
import { CategoryNamePipe } from '../pipes/category-name/category-name';
import { IconPipe } from '../pipes/icon/icon';
import { TransDatePipe } from '../pipes/trans-date/trans-date';
import { TwoNumPipe } from '../pipes/two-num/two-num';
import { AdsProvider } from '../providers/ads/ads';
import { CategoriesProvider } from '../providers/categories/categories';
import { ConfigProvider } from '../providers/config/config';
import { EventProvider } from '../providers/event/event';
import { GoogleMapsProvider } from '../providers/google-maps/google-maps';
import { LoaderProvider } from '../providers/loader/loader';
import { LocationProvider } from '../providers/location/location';
import { NotificationProvider } from '../providers/notification/notification';
import { RequestProvider } from '../providers/request/request';
import { ResultProvider } from '../providers/result/result';
import { SessionProvider } from '../providers/session/session';
import { SettingsProvider } from '../providers/settings/settings';
import { DarkMode } from '../providers/dark-mode/dark-mode';
import { SharingProvider } from '../providers/sharing/sharing';
import { UserProvider } from '../providers/user/user';
import { ValueProvider } from '../providers/value/value';
import { TutorialProvider } from '../providers/tutorial/tutorial';
import { EncodeHttpParamsInterceptor } from '../tools/overwrites/CustomHttpEncoder';
import { MyApp } from './app.component';
import { EventMembersPage } from '../pages/event/details/event-members/event-members';
import { NewsProvider } from '../providers/news/news';
import { ResultDetailsTabsPage } from '../pages/results/result-details/result-details-tabs/result-details-tabs';
import { ResultDetailsThumbupPage } from '../pages/results/result-details/result-details-thumbup/result-details-thumbup';
import { ResultDetailsCommentPage } from '../pages/results/result-details/result-details-comment/result-details-comment';
import { ResultCategoryPage } from '../pages/results/result-category/result-category';
import { ResultTotalPage } from '../pages/results/results-total/result-total';
import { MenuLayerCategoryComponent } from '../components/menu-layer-category/menu-layer-category';
import { MenuLayerTotalComponent } from '../components/menu-layer-total/menu-layer-total';
import { ResultEventDetailsPage } from '../pages/results/result-event-details/result-event-details';
import { ResultMenuToolbarComponent } from '../components/result-menu-toolbar/result-menu-toolbar';
import { TestPage } from '../pages/test-page/test-page';
import { AdsenseModule } from 'ng2-adsense';
import { GoogleAdsComponent } from '../components/google-ads/google-ads';
import { Deeplinks } from '@ionic-native/deeplinks';
import { DeeplinkProvider } from '../providers/deeplink/deeplink';
import { BackgroundGeolocation } from '@ionic-native/background-geolocation';
import { StrackerPage } from '../tracker/sencha-tracker/stracker';
import { PopupRegistrationComponent } from '../components/popup-registration/popup-registration';
import { NativeAudio } from '@ionic-native/native-audio';
import { TrackingSettingsPage } from '../pages/tracking-settings/tracking-settings';
import { DeviceMotion } from '@ionic-native/device-motion';
import { AudioSystemProvider } from '../providers/audio-system/audio-system';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { BibNumberComponent } from '../components/bib-number/bib-number';
import { ResultAddPage } from '../pages/results/result-add/result-add';
import { StrackerProvider } from '../providers/stracker/stracker';
import { Instagram } from '@ionic-native/instagram';
import { Diagnostic } from '@ionic-native/diagnostic';
import { PhotoLibrary } from '@ionic-native/photo-library';
import { File } from '@ionic-native/file';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery';
import { StorageProvider } from '../providers/storage-service/storage-service';
import { PermissionPage } from '../tracker/sencha-tracker/tutorial-permission/permission';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { Dialogs } from '@ionic-native/dialogs';
import { WelcomeRestylePage } from '../pages/welcome/welcome-restyle/welcome-restyle';
import { LineChartComponent } from '../components/chart/line-chart';
import { ResultDescriptionPage } from '../pages/results/result-description/result-description';
import { IdRegistrationPage } from '../pages/login/id-registration/id-registration';
import { AppDetectorProvider } from '../providers/detector/detector';
import { InBrowserPage } from '../pages/browser/inbrowser';
import { EventDetailsResolver } from '../pages/event/details/event-details/event-details-resolver';
import { TrackPage } from '../tracker/track-page/trackpage';
import { EventActivityPage } from '../pages/event/event-activity-tabs/event-forest/event-activity';
import { PaymentComponent } from '../components/payment/payment';
import { PayPal } from '@ionic-native/paypal';
import { Stripe } from '@ionic-native/stripe';
import { PaymentProvider } from '../providers/payment/payment';
import { EventPersonInformationPage } from '../pages/event/details/event-person-information/event-person-information';
import { EventPaymentPage } from '../pages/event/details/event-payment/event-payment';
import { EventDetailsShopPage } from '../pages/event/details/event-details-shop/event-details-shop';
import { InstantPaypal } from '../pages/instantpaypal/instant-paypal';
import { ResultTeamsPage } from '../pages/results/result-teams/result-teams';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { LidProvider } from '../providers/lid-provider/lid-provider';
import { LeaderTrack } from '../tracker/leader-track-page/leader-track';
import { AnmeldungenPage } from '../pages/anmeldungen-page/anmeldungen-page';
import { RaceProvider } from '../providers/race-provider/race-provider';
import { ScoreBoardWallen } from '../components/score-board-wallen/score-board-wallen';
import { ScoreBoardBib } from '../components/scoreboard-bib/scoreboard-bib';
import { ScoreBoardName } from '../components/scoreboard-by-name/scoreboard-by-name';
import { EditAthleteData } from '../pages/edit-athlete-data/edit-athlete-data';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { EventDetailsNewDesignResolver } from '../pages/event/details/event-details-new-design/event-details-new-design-details-resolver';
import { Calendar } from '@ionic-native/calendar';
import { EventDetailsNewDesignPage } from '../pages/event/details/event-details-new-design/event-details-new-design';
import { InstantPaymentPage } from '../pages/payment-system/instant-payment';
import { SuccessPaymentPage } from '../pages/payment-system/success-payment/success-payment';
import { MysportRoutesPage } from '../pages/me/mysport/mysport-routes/mysport-routes';
import { EventActivityTabsPage } from '../pages/event/event-activity-tabs/event-activity-tabs';
import { ActivityFriendsPage } from '../pages/event/event-activity-tabs/activity-friends/activity-friends';
import { ActivityStatisticsPage } from '../pages/event/event-activity-tabs/activity-statistics/activity-statistics';
import { MyRoutesComponent } from '../components/my-routes/my-routes-component';
import { TrophyCustomComponent } from '../components/trophy-custom/trophy-custom';
import { ParticipantListComponent } from '../components/participant-list/participant-list';
import { PopoverFeedComponent } from '../components/popover-feed/popover-feed';
import { LineupPage } from '../pages/apps/lineup/lineup';
import { PlayerComponent } from '../pages/apps/lineup/components/player/player';
import { OnMoveDirective } from '../pages/apps/lineup/directives/tshirt-change/on-move';
import { SvgTshirtContainerComponent } from '../pages/apps/lineup/components/svg-image-container/svg-tshirt-container';
import { CreatePlayerComponent } from '../pages/apps/lineup/components/create-player/create-player';
import { LineUpService } from '../pages/apps/lineup/services/lineup-service';
import { ToolbarMainComponent } from '../pages/apps/lineup/components/toolbar/toolbar-main/toolbar-main';
import { ToolbarFieldComponent } from '../pages/apps/lineup/components/toolbar/toolbar-field/toolbar-field';
import { ToolbarTshirtComponent } from '../pages/apps/lineup/components/toolbar/toolbar-tshirt/toolbar-tshirt';
import { SettingsComponent } from '../pages/apps/lineup/components/toolbar/settings/toolbar-settings';
import { CreateTeamComponent } from '../pages/apps/lineup/components/create-team/create-team';
import { PaginatorComponent } from '../pages/apps/lineup/components/shared/paginator/paginator';
import { PlanOptionComponent } from '../pages/apps/gamer/components/plan-option/plan-option';
import { TournamentService } from '../pages/apps/gamer/services/tournament.service';
import { PlanOnePage } from '../pages/apps/gamer/pages/new-tou/new-plan/plan-one/plan-one';
import { TeamSettingsComponent } from '../components/team-settings/team-settings';
import { ParticipantPage } from '../pages/participant-page/participant-page';
import { PlanKoPage } from '../pages/apps/gamer/pages/new-tou/new-plan/plan-ko/plan-ko';
import { PreRoundPage } from '../pages/apps/gamer/pages/new-tou/new-plan/pre-round/pre-round';
import { PreRoundKoPage } from '../pages/apps/gamer/pages/new-tou/new-plan/pre-round-ko/pre-round-ko';
import { TwoGruppeKoPage } from '../pages/apps/gamer/pages/new-tou/new-plan/two-group-ko/two-group-ko';
import { PlanTypePipe } from '../pages/apps/gamer/pipes/plan-type/plan-type';
import { TeamSettingsModal } from '../pages/team-settings-modal/team-settings-modal';
import { ResultEditOnePage } from '../pages/apps/gamer/pages/edits/one-page/edit-one-page';
import { ResultEditPreRoundPage } from '../pages/apps/gamer/pages/edits/pre-round/edit-pre-round';
import { ResultEditKoPage } from '../pages/apps/gamer/pages/edits/ko-page/edit-ko';
import { ResultEditPreroundKoPage } from '../pages/apps/gamer/pages/edits/pre-round-ko/preround-edit-ko';
import { PlanScratchFilterPipe } from '../pages/apps/gamer/pipes/plan-list-filter/plan-list-filter';
import { Crop } from '@ionic-native/crop';
import { AngularDraggableModule } from 'angular2-draggable';
import { TwoGKoPlPage } from '../pages/apps/gamer/pages/new-tou/new-plan/twog-ko-pl/twog-ko-pl';
import { EditTwoGKoPlPage } from '../pages/apps/gamer/pages/edits/twog-ko-pl/twog-ko-pl';
import { MeKoPage } from '../pages/apps/gamer/pages/new-tou/new-plan/me-ko/me-ko';
import { EditMeKoPage } from '../pages/apps/gamer/pages/edits/me-ko/me-ko-edit';
import { TouListPage } from '../pages/apps/gamer/pages/tou-list/tou-list';
import { NewTouMainPage } from '../pages/apps/gamer/pages/new-tou/new-tou-main';
import { GamerTeamsPage } from '../pages/apps/gamer/pages/team-list/gamer-teams';
import { GamerResultOnePage } from '../pages/apps/gamer/pages/results/result-one/result-one';
import { GamerResultKoPage } from '../pages/apps/gamer/pages/results/result-ko/result-ko';
import { ResultPreRoundKoPage } from '../pages/apps/gamer/pages/results/result-pre-round-ko/result-pre-round-ko';
import { ResultPreRoundPage } from '../pages/apps/gamer/pages/results/result-pre-round/result-pre-round';
import { ResultGroupKoPage } from '../pages/apps/gamer/pages/results/result-group-ko/result-group-ko';
import { PlanResultsMainPage } from '../pages/apps/gamer/pages/results/main/plan-result-main';
import { MapGameTablePage } from '../pages/apps/gamer/pages/results/result-ko/map-game-table/map-game-table';
import { KoOverviewPage } from '../pages/apps/gamer/pages/results/result-ko/overview/ko-overview';
import { GroupKoOverviewPage } from '../pages/apps/gamer/pages/results/result-group-ko/overview/group-ko-overview';
import { GroupKoGameTablePage } from '../pages/apps/gamer/pages/results/result-group-ko/map-game-table/map-game-table';
import { PreroundKoOverviewPage } from '../pages/apps/gamer/pages/results/result-pre-round-ko/overview/preround-ko-overview';
import { PreroundKoGameTablePage } from '../pages/apps/gamer/pages/results/result-pre-round-ko/map-game-table/preround-ko-map-game-table';
import { ResultTwoGKoPlPage } from '../pages/apps/gamer/pages/results/result-twog-ko-pl/result-twog-ko-pl';
import { ResultTwoGKoPlOverviewPage } from '../pages/apps/gamer/pages/results/result-twog-ko-pl/overview/result-twog-ko-pl-overview';
import { ResultTwoGKoPlTablePage } from '../pages/apps/gamer/pages/results/result-twog-ko-pl/map-game-table/result-twog-ko-pl-table';
import { ResultMeKoPage } from '../pages/apps/gamer/pages/results/result-me-ko/result-me-ko';
import { ResultMeKoOverviewPage } from '../pages/apps/gamer/pages/results/result-me-ko/overview/result-me-ko-overview';
import { ResultMeKoTablePage } from '../pages/apps/gamer/pages/results/result-me-ko/map-game-table/result-me-ko-table';
import { OfflineService } from '../pages/apps/gamer/services/offline.service';
import { SortByOrderPipe } from '../pages/apps/lineup/directives/sort-by-order/sort-by-order';
import { LineTestPage } from '../pages/apps/lineup/testpage/test-lineup';
import { ImgService } from '../pages/apps/gamer/services/img.service';
import { TeamSettings } from '../pages/team-settings/team-settings';
import { GeolocationService } from '../providers/geolocation-service/geolocation-service';
import { QRScanner } from '@ionic-native/qr-scanner';
import { EventTester } from '../pages/event/main/event-tester/event-tester';

import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { ScreenRotatableService } from '../providers/screen-rotatable/screen-rotatable.service';
import { TrackingService } from '../providers/tracking.service';
import { DeviceOrientation } from '@ionic-native/device-orientation';
import { ActivityService } from '../providers/activities.service';
import { EventDetailsService } from '../providers/event-detailts.service';
import { MysportPurchasesPage } from '../pages/me/mysport/mysport-purchases/mysport-purchases';

import { PaymentService } from '../providers/payment.service';
import { PremiumPaymentPage } from '../pages/premium/premium-payment/premium-payment';
import { PremiumBannerPage } from '../pages/premium/premium-banner/premium-banner';
import { QRCodePage } from '../pages/me/qrcode/qrcode';
import { ActivityImportComponent } from '../pages/event/event-activity-tabs/activity-import/activity-import';
import { EventsLauncherService } from '../providers/events-launcher.service';
import { TutorialsComponent } from '../components/tutorials/tutorials.component';
import { ModalConfigureGeoComponent } from '../components/modal-configure-geo/modal-configure-geo';
import { ExternalFeedsPage } from '../pages/event/event-activity-tabs/external-feeds-page/external-feeds-page';
import { EventsBlockWithContainersComponent } from '../components/events-block-with-containers/events-block-with-containers';
import { ContainersWithItemsComponent } from '../components/container-with-items/container-with-items';

export class CustomHammerConfig extends HammerGestureConfig {
  overrides = {
    'press': { time: 5000 }  //set press delay for 5 second
  }
}

@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    RegistrationPage,
    TabsPage,
    EventSearchPage,
    ResultSearchPage,
    NearbyMapPage,
    EventCreatePage,
    EventCreateTabsPage,
    InfosPage,
    KontaktPage,
    FotosPage,
    MysportContactsPage,
    MysportResultsPage,
    MysportEventsPage,
    MysportPhotosPage,
    MysportFriendsPage,
    PrivateProfilePage,
    SettingsPage,
    ResultDetailsPage,
    ResultProfilePage,
    ResultRanglistPage,
    EventDetailsPage,
    EventTabsPage,
    EventKontaktPage,
    ImageContainerComponent,
    EventDetailInfoPage,
    TextDataProtectPage,
    NotificationPage,
    NotificationDetailsPage,
    TextBuildingServicesPage,
    TextImpressPage,
    TextCookiesPage,
    TextContactPage,
    ScrollHideDirective,
    MysportUserProfilePage,
    EventSearchListItemComponent,
    ResultSearchListItemComponent,
    ScoreBoardModal,
    ScoreBoardEinzel,
    RaceByBib,
    LeaderActivity,
    RaceByName,
    ScoreBoardWallen,
    ScoreBoardBib,
    ScoreBoardName,
    ResultRanglistListItemComponent,
    MyEventListItemComponent,
    MysportProfileListItemComponent,
    EventSearchMapPage,
    GoogleMapsComponent,
    EventListPage,
    EventDetailsMapPage,
    ResultCreatePagerPage,
    IconPipe,
    CategoryNamePipe,
    TwoNumPipe,
    PlanTypePipe,
    PlanScratchFilterPipe,
    TransDatePipe,
    SortByOrderPipe,
    MysportIconComponent,
    MenuLayerCategoryComponent,
    MenuLayerTotalComponent,
    PictureViewerPage,
    TrophyComponent,
    ResultEditTrophyPage,
    MeSettingsSportartsPage,
    EventCreateRacePage,
    PrivateProfilePhotosPage,
    GoogleAdsDirective,
    NearbyModifyStartPage,
    WelcomePage,
    NearbyEventParticipantSearchPage,
    NearbyEventParticipantsPage,
    MysportSportartListItemComponent,
    EventMembersPage,
    MysportResultsMenuPage,
    ResultDetailsTabsPage,
    ResultDetailsThumbupPage,
    ResultDetailsCommentPage,
    ResultCategoryPage,
    ResultTotalPage,
    ResultEventDetailsPage,
    ResultMenuToolbarComponent,
    GoogleAdsComponent,
    StrackerPage,
    TestPage,
    PopupRegistrationComponent,
    TrackingSettingsPage,
    BibNumberComponent,
    ResultAddPage,
    PermissionPage,
    WelcomeRestylePage,
    LineChartComponent,
    ResultDescriptionPage,
    IdRegistrationPage,
    InBrowserPage,
    TrackPage,
    EventActivityPage,
    PaymentComponent,
    TakeSelfiePage,
    CountdownComponent,
    EventPersonInformationPage,
    EventPaymentPage,
    EventDetailsShopPage,
    InstantPaypal,
    ResultTeamsPage,
    AnmeldungenPage,
    EditAthleteData,
    LeaderTrack,
    EventDetailsNewDesignPage,
    InstantPaymentPage,
    SuccessPaymentPage,
    MysportRoutesPage,
    EventActivityTabsPage,
    ActivityFriendsPage,
    ActivityStatisticsPage,
    MyRoutesComponent,
    TrophyCustomComponent,
    ParticipantListComponent,
    PopoverFeedComponent,
    PremiumBannerPage,
    PremiumPaymentPage,
    LineupPage,
    PlayerComponent,
    OnMoveDirective,
    SvgTshirtContainerComponent,
    CreatePlayerComponent,
    ToolbarMainComponent,
    ToolbarFieldComponent,
    ToolbarTshirtComponent,
    SettingsComponent,
    CreateTeamComponent,
    PaginatorComponent,
    TouListPage,
    NewTouMainPage,
    PlanOnePage,
    PlanOptionComponent,
    TeamSettingsComponent,
    ParticipantPage,
    GamerTeamsPage,
    ResultEditOnePage,
    ResultEditPreRoundPage,
    PlanKoPage,
    GamerResultOnePage,
    GamerResultKoPage,
    PreRoundPage,
    PreRoundKoPage,
    TwoGruppeKoPage,
    ResultPreRoundKoPage,
    EventActivityPage,
    ResultPreRoundPage,
    TeamSettings,
    ResultGroupKoPage,
    PlanResultsMainPage,
    TeamSettingsModal,
    MapGameTablePage,
    KoOverviewPage,
    ResultEditKoPage,
    GroupKoOverviewPage,
    GroupKoGameTablePage,
    PreroundKoOverviewPage,
    PreroundKoGameTablePage,
    ResultEditPreroundKoPage,
    ResultTwoGKoPlPage,
    TwoGKoPlPage,
    EditTwoGKoPlPage,
    ResultTwoGKoPlOverviewPage,
    ResultTwoGKoPlTablePage,
    MeKoPage,
    EditMeKoPage,
    ResultMeKoPage,
    ResultMeKoOverviewPage,
    ResultMeKoTablePage,
    LineTestPage,
    QRCodePage,
    ActivityImportComponent,
    EventTester,
    EventOrganizerPage,
    MysportPurchasesPage,
    AddAthletePage,
    EventsLauncherPage,
    TutorialsComponent,
    TouItemComponent,
    ModalConfigureGeoComponent,
    ExternalFeedsPage,
    EventsBlockWithContainersComponent,
    ContainersWithItemsComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    GooglePayButtonModule,
    AngularDraggableModule,
    IonicModule.forRoot(MyApp, {
      swipeBackEnabled: true
    }),
    IonicStorageModule.forRoot({
      name: '__spooortsdb',
      driverOrder: ['sqlite', 'indexeddb', 'websql', 'localstorage']
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AdsenseModule.forRoot({
      adClient: 'ca-pub-3372584184973915',
      adSlot: 3539102521
    }),

  ],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    TabsPage,
    EventSearchPage,
    ResultSearchPage,
    NearbyMapPage,
    EventCreatePage,
    EventCreateTabsPage,
    InfosPage,
    KontaktPage,
    FotosPage,
    LoginPage,
    RegistrationPage,
    MysportContactsPage,
    MysportResultsPage,
    MysportEventsPage,
    MysportPhotosPage,
    MysportFriendsPage,
    PrivateProfilePage,
    SettingsPage,
    ResultDetailsPage,
    ResultProfilePage,
    ResultRanglistPage,
    EventActivityPage,
    EventDetailsPage,
    EventTabsPage,
    EventKontaktPage,
    ImageContainerComponent,
    EventDetailInfoPage,
    TextDataProtectPage,
    NotificationPage,
    NotificationDetailsPage,
    TextBuildingServicesPage,
    TextImpressPage,
    TextCookiesPage,
    TextContactPage,
    MysportUserProfilePage,
    EventSearchListItemComponent,
    ResultSearchListItemComponent,
    ScoreBoardModal,
    ScoreBoardEinzel,
    RaceByBib,
    RaceByName,
    LeaderActivity,
    ScoreBoardWallen,
    ScoreBoardBib,
    ScoreBoardName,
    ResultRanglistListItemComponent,
    MyEventListItemComponent,
    MysportProfileListItemComponent,
    EventSearchMapPage,
    GoogleMapsComponent,
    EventListPage,
    EventDetailsMapPage,
    ResultCreatePagerPage,
    MysportIconComponent,
    MenuLayerCategoryComponent,
    MenuLayerTotalComponent,
    PictureViewerPage,
    ResultEditTrophyPage,
    MeSettingsSportartsPage,
    EventCreateRacePage,
    PrivateProfilePhotosPage,
    NearbyModifyStartPage,
    WelcomePage,
    NearbyEventParticipantSearchPage,
    NearbyEventParticipantsPage,
    MysportSportartListItemComponent,
    EventMembersPage,
    MysportResultsMenuPage,
    ResultDetailsTabsPage,
    ResultDetailsThumbupPage,
    ResultDetailsCommentPage,
    ResultCategoryPage,
    ResultTotalPage,
    ResultEventDetailsPage,
    ResultMenuToolbarComponent,
    GoogleAdsComponent,
    StrackerPage,
    TestPage,
    PopupRegistrationComponent,
    TrackingSettingsPage,
    BibNumberComponent,
    ResultAddPage,
    PermissionPage,
    WelcomeRestylePage,
    LineChartComponent,
    ResultDescriptionPage,
    IdRegistrationPage,
    InBrowserPage,
    TrackPage,
    PaymentComponent,
    TakeSelfiePage,
    CountdownComponent,
    EventPersonInformationPage,
    EventPaymentPage,
    EventDetailsShopPage,
    InstantPaypal,
    ResultTeamsPage,
    LeaderTrack,
    AnmeldungenPage,
    EditAthleteData,
    EventDetailsNewDesignPage,
    InstantPaymentPage,
    SuccessPaymentPage,
    MysportRoutesPage,
    EventActivityTabsPage,
    ActivityFriendsPage,
    ActivityStatisticsPage,
    MyRoutesComponent,
    TrophyCustomComponent,
    ParticipantListComponent,
    PopoverFeedComponent,
    PremiumBannerPage,
    PremiumPaymentPage,
    LineupPage,
    PlayerComponent,
    SvgTshirtContainerComponent,
    CreatePlayerComponent,
    ToolbarMainComponent,
    ToolbarFieldComponent,
    ToolbarTshirtComponent,
    SettingsComponent,
    CreateTeamComponent,
    PaginatorComponent,
    TouListPage,
    NewTouMainPage,
    PlanOnePage,
    ParticipantPage,
    PlanOptionComponent,
    GamerTeamsPage,
    GamerResultOnePage,
    GamerResultKoPage,
    ResultEditOnePage,
    ResultEditPreRoundPage,
    PlanKoPage,
    PreRoundPage,
    PreRoundKoPage,
    TwoGruppeKoPage,
    ResultPreRoundKoPage,
    ResultPreRoundPage,
    ResultGroupKoPage,
    PlanResultsMainPage,
    TeamSettingsModal,
    KoOverviewPage,
    ResultEditKoPage,
    GroupKoOverviewPage,
    GroupKoGameTablePage,
    PreroundKoOverviewPage,
    PreroundKoGameTablePage,
    ResultEditPreroundKoPage,
    ResultTwoGKoPlPage,
    TwoGKoPlPage,
    EditTwoGKoPlPage,
    ResultTwoGKoPlOverviewPage,
    ResultTwoGKoPlTablePage,
    MeKoPage,
    EditMeKoPage,
    TeamSettings,
    ResultMeKoPage,
    ResultMeKoOverviewPage,
    ResultMeKoTablePage,
    LineTestPage,
    EventTester,
    EventOrganizerPage,
    QRCodePage,
    ActivityImportComponent,
    MysportPurchasesPage,
    AddAthletePage,
    EventsLauncherPage,
    TutorialsComponent,
    TouItemComponent,
    ModalConfigureGeoComponent,
    ExternalFeedsPage,
    EventsBlockWithContainersComponent,
    ContainersWithItemsComponent
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EncodeHttpParamsInterceptor,
      multi: true
    },
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    CategoriesProvider,
    HttpClient,
    ValueProvider,
    ConfigProvider,
    EventProvider,
    UserProvider,
    ResultProvider,
    GoogleMapsProvider,
    Camera,
    PhotoLibrary,
    IconPipe,
    RequestProvider,
    DatePipe,
    TwoNumPipe,
    PlanTypePipe,
    PlanScratchFilterPipe,
    CategoryNamePipe,
    TransDatePipe,
    SortByOrderPipe,
    RequestProvider,
    Geolocation,
    LoaderProvider,
    InAppBrowser,
    SettingsProvider,
    DarkMode,
    Facebook,
    Transfer,
    TransferObject,
    File,
    GooglePlus,
    SocialSharing,
    SharingProvider,
    NotificationProvider,
    Push,
    Device,
    AdsProvider,
    TapticEngine,
    SessionProvider,
    RaceProvider,
    LocationProvider,
    AppVersion,
    NearbyMainResolver,
    NewsProvider,
    TutorialProvider,
    Deeplinks,
    DeeplinkProvider,
    BackgroundGeolocation,
    NativeAudio,
    DeviceMotion,
    AudioSystemProvider,
    LocalNotifications,
    StrackerProvider,
    Instagram,
    Diagnostic,
    PhotoLibrary,
    Base64ToGallery,
    AndroidPermissions,
    StorageProvider,
    AppDetectorProvider,
    Dialogs,
    EventDetailsResolver,
    PayPal,
    Stripe,
    PaymentProvider,
    LidProvider,
    EventDetailsNewDesignResolver,
    Calendar,
    LineUpService,
    TournamentService,
    OfflineService,
    Crop,
    ImgService,
    QRScanner,
    GeolocationService,
    ScreenOrientation,
    TrackingService,
    DeviceOrientation,
    ScreenRotatableService,
    ActivityService,
    NodeToImgService,
    PaymentService,
    Media,
    ScanService,
    MenuEntriesService,
    EventDetailsService,
    EventsLauncherService,
    ToastController
  ]
})
export class AppModule {

  constructor(private injector: Injector) {
    AppInjector = this.injector;
    // private statusBar: StatusBar
    // let status bar overlay webview
    // this.statusBar.overlaysWebView(true);
    // set status bar to white
    // this.statusBar.backgroundColorByHexString('#ffffff');
  }
}

export let AppInjector: Injector;

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}



// WEBPACK FOOTER //
// /src/app/app.module.ts